import React, { createContext, useContext, useState } from 'react';
import consultaWeb from '../services/consultaWeb';

interface IAutoRequestContext {
  cnjs: string[];
  setCnjs: (data: string[], options?: { makeDownload?: boolean; forced?: boolean }) => void;
  autoRequestOptions: { makeDownload?: boolean; forced?: boolean };
  createAutoRequest: (cnj: string, options?: { makeDownload?: boolean; forced?: boolean }) => any;
}
export const AutoRequestContext = createContext<IAutoRequestContext>({
  cnjs: [],
  setCnjs: (data: string[], options?: { makeDownload?: boolean; forced?: boolean }) => {},
  autoRequestOptions: {},
  createAutoRequest: (cnj: string, options?: { makeDownload?: boolean; forced?: boolean }) => {},
});
const AutoRequestProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cnjs, setCnjsState] = useState<string[]>([]);
  const [autoRequestOptions, setAutoRequestOptions] = useState<{ makeDownload?: boolean; forced?: boolean }>({});
  const setCnjs = (data: string[], options?: { makeDownload?: boolean; forced?: boolean }) => {
    setCnjsState(data);
    setAutoRequestOptions(options || {});
  };
  const createAutoRequest = async (cnj: string, options?: { makeDownload?: boolean; forced?: boolean }): Promise<any> => {
    // Usa as opções passadas, ou as opções padrão do contexto
    const finalOptions = options || autoRequestOptions;
    try {
      let response = await consultaWeb.autoRequest({ 
        cnj, 
        makeDownload: finalOptions?.makeDownload || false,
        forced: finalOptions?.forced || false,
      });
      return response;
    } catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  };
  return (
    <AutoRequestContext.Provider
      value={{
        cnjs,
        setCnjs,
        autoRequestOptions,
        createAutoRequest,
      }}
    >
      {children}
    </AutoRequestContext.Provider>
  );
};

const useAutoRequest = (): IAutoRequestContext => {
  const context = useContext(AutoRequestContext);
  if (!context) {
    throw new Error('useAutoRequest must be used within an AutoRequestProvider');
  }
  return context;
};

export { AutoRequestProvider, useAutoRequest };
